module.exports = __webpack_public_path__ + "img/23_118.5ad0ed4b.png";